import { useEffect, useState, useContext } from "react";
import UserContext from "../../contexts/userContext"; 
import ErrorContext from "../../contexts/errorContext";

import Card from 'react-bootstrap/Card';
import Placeholder from 'react-bootstrap/Placeholder';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Typewriter from "../Typewriter";
import { HTML } from "../HTML";

import { retryFetch } from "../../utils";
import { addConversation } from "./2-1_ConversationCards";
import { getTemplates } from "../chat/2-1_ChatPromptTemplates";
import "../../styles/DocumentList.css"

export const DocumentList = () => {
    const { userContext, setUserContext, setAccount } = useContext(UserContext);
    const showAllDocs = userContext.showAllDocs || false;
    
    const { setErrorContext } = useContext(ErrorContext);
    const [ docs, setDocs ] = useState();

    const doSetDocument = (doc) => {
        if (userContext.templates === undefined) {
            return;
        }
        const conversationOverviews = doc.conversations || [];
        const doAddConversation = conversationOverviews.length === 0
    
        const tempUserContext = {...userContext};
        tempUserContext.document = doc;
        delete tempUserContext.conversationOverview;
        delete tempUserContext.conversation;
    
        if (doAddConversation) { 
            addConversation(0, {userContext:tempUserContext, setUserContext, setAccount});
        } else {
            setUserContext(tempUserContext);
        }
    }

    const getDocs = (retryCount) => {
        if (docs) {
            return;
        }

        console.log('getting docs')
        const apiGatewayInvokeUrl = process.env[`REACT_APP_API_GATEWAY_INVOKE_URL__${process.env["REACT_APP_DEPLOYMENT_TYPE"]}`]
        const endpoint = `${apiGatewayInvokeUrl}/doc${showAllDocs ? '?showAllDocs=true' : ''}`;
        const params = {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${userContext.account.idToken}`
            }
        };

        fetch(endpoint, params)
            .then(response => response.json())
            .then(docs => {
                setDocs(docs);
            })
            .catch(e => {
                console.log('error fetching documents', e);
                retryFetch(userContext, setAccount, retryCount||0, getDocs, {});
            });
    }

    useEffect(getDocs, [showAllDocs]);
    useEffect(() => {
        if (docs === undefined || userContext.templates) {
            return;
        }

        if (userContext.templates === undefined) {
            getTemplates(0, {userContext, setUserContext, setAccount}).then(templates => {
                const isNewUser = docs[0].conversations.length===0;
                const tempUserContext = {...userContext};
                tempUserContext.templates = templates;
                tempUserContext.tour = (isNewUser && typeof userContext.tour === 'undefined');
                setUserContext(tempUserContext);
            });
        }
    }, [docs])

    return (
        <>
            <h3 className="mt-4 a8-orange" style={{"textAlign":"center", "fontFamily":"PP Neue Montreal"}}>
                <Typewriter text="Welcome to the Analytics8 Chatbot" />
            </h3>
            <h6 style={{"textAlign":"center", "fontWeight":"bold"}}>
                &nbsp;
                <Typewriter
                    text="^Select a body of knowledge to get started"
                    pauseDelay={1300}
                />
            </h6>
            <Row xs={1} sm={1} md={3} lg={4} className="ms-auto docCardRow g-4">
                {docs ? (
                    <>
                        {docs.length==2 && <Col className="docListPadder" />}
                        
                        {docs.map((doc, i) => {
                            return <DocCard 
                                key={`${doc.documentid}${doc.userid}`}
                                id={`docCard${i}`}
                                className={i>0 ? 'a8-proprietary' : ''}
                                disabled={true}
                                onClick={() => doSetDocument(doc)}
                                headerIconClass={i===0 ? 'bi-slash-square pe-1' : 'bi-file-earmark-text pe-1'}
                                headerContent={doc.filename}
                                headerBottom={showAllDocs && doc.userid}
                                bodyContent={doc.description}
                                bodyBottom={`Conversations: ${doc.conversations.length}`}
                             />
                        })}

                        <DocCard 
                            onClick={() => setErrorContext({
                                type:'comingSoon',
                                manualClose: true,
                                useTypewriter: true,
                                body:`^Document upload funtionality is not yet available, but you can still give the chatbot additional knowledge by using "query context."~^~Please see the Help menu for more information.`
                            })}
                            headerIconClass={'bi-plus-circle pe-1'}
                            headerContent='New Document'
                            bodyContent='Give the chatbot additional knowledge by uploading a document of information it will use when answering questions or responding to commands'
                            bodyBottom={<br/>}
                        />
                    </>
                ) : (
                    <>
                        <Col className="docListPadder" />
                        <DocCardPlaceholder />
                        <DocCardPlaceholder />
                        <DocCardPlaceholder />
                    </>
                )}
            </Row>
        </>
    )
};

const DocCard = ({id, className, onClick, headerIconClass, headerContent, headerBottom, bodyContent, bodyBottom}) => {
    return (
        <Col>
            <Card
                className={`docCard no-text-decoration ${className || ''}`}
                id={id}
                onClick={onClick}
            >
                <Card.Header>
                    <i style={{"color":"white"}} className={headerIconClass} />
                    {headerContent}
                    {headerBottom && <><br/>{headerBottom}</>}
                </Card.Header>
                <Card.Body>
                    <HTML
                        className="docCardBody"
                        text={bodyContent}
                        doCreateParagraphs={true}
                    />
                    <i className="text-muted">{bodyBottom}</i>
                </Card.Body>
            </Card>
        </Col>
    );
}
 
const DocCardPlaceholder = () => {
    return (
        <Col>
            <Card style={{ width: '22rem' }} className="m-4">
                <Placeholder as={Card.Header}  style={{height: '4rem'}} animation="glow">
                    <Placeholder xs={11} />
                </Placeholder>
                <Card.Body>
                    <Placeholder animation="glow" >
                        <div className="docCardBody">
                        
                        <Placeholder xs={4} /> <Placeholder xs={3} /> <Placeholder xs={2} />
                        <Placeholder xs={3} /> <Placeholder xs={1} /> <Placeholder xs={4} /><br />
                        <Placeholder xs={4} /> <Placeholder xs={6} /> <br />
                        
                        </div>
                        <Placeholder xs={5} /> <Placeholder xs={1} /> <br />
                    </Placeholder>
                </Card.Body>
            </Card>
        </Col>
    );
}